import {gql} from "@apollo/client";

export const GET_ALL_TENANTS = gql`
    query GetAllTenants {
        tenants(pagedInput: {
            pageInfo: {
                pageIndex: 0,
                pageSize: 1000
            },
            orderAsc: true,
            orderField: "lastName",
            filter: {}
        }) {
            items {
                id
                firstName
                lastName
                email
            }
        }
    }
`;

export const GET_TENANTS = gql`
    query GetTenants($pageIndex: Int!, $pageSize: Int!, $orderAsc: Boolean!, $orderField: String!, $filter: JSON) {
        tenants(pagedInput: {
            pageInfo: {
                pageIndex: $pageIndex,
                pageSize: $pageSize
            },
            orderAsc: $orderAsc,
            orderField: $orderField,
            filter: $filter
          }) {
            items {
                id
                firstName
                lastName
                email
                primaryPhone
                secondaryPhone
                properties {
                    id
                }
                hasFicaDocument
                hasIdDocument
                bankingDetails
            }
            pageInfo {
                totalCount
                totalPages
                pageSize
                pageIndex
            }
        }
    }
`;

export const GET_TENANT = gql`
    query GetTenant($id: ID!) {
        tenant(id: $id) {
            id
            firstName
            lastName
            email
            primaryPhone
            secondaryPhone
            hasFicaDocument
            hasIdDocument
            properties {
                id
                address {
                    street
                    suburb
                    city
                    postalCode
                }
                status
            }
            bankingDetails
            bankingDetailsInfo {
                bankName
                accountNumber
                accountType
                branchCode
                accountHolder
            }
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_TENANT = gql`
    mutation CreateTenant($input: TenantInput!) {
        createTenant(inputData: $input) {
            id
            firstName
            lastName
        }
    }
`;

export const UPDATE_TENANT = gql`
    mutation UpdateTenant($id: ID!, $input: TenantInput!) {
        updateTenant(id: $id, inputData: $input) {
            id
            firstName
            lastName
        }
    }
`;

export const DELETE_TENANT = gql`
    mutation DeleteTenant($id: ID!) {
        deleteTenant(id: $id)
    }
`;

export const GET_TENANT_DOCUMENTS = gql`
    query GetTenantDocuments($id: ID!) {
        tenant(id: $id) {
            id
            firstName
            lastName
            email
            bankingDetails
            bankingDetailsInfo {
                bankName
                accountNumber
                accountType
                branchCode
                accountHolder
            }
            documents {
                id
                name
                type
                url
                uploadedAt
            }
        }
    }
`;

export const UPLOAD_TENANT_DOCUMENT = gql`
    mutation UploadTenantDocument($tenantId: ID!, $file: Upload!, $type: String!) {
        uploadTenantDocument(tenantId: $tenantId, file: $file, type: $type) {
            id
            name
            type
            url
            uploadedAt
        }
    }
`;

export const DELETE_TENANT_DOCUMENT = gql`
    mutation DeleteTenantDocument($id: ID!) {
        deleteTenantDocument(id: $id)
    }
`;

export const UPDATE_TENANT_BANKING_DETAILS = gql`
    mutation UpdateTenantBankingDetails($tenantId: ID!, $input: BankingDetailsInput!) {
        updateTenantBankingDetails(tenantId: $tenantId, input: $input) {
            id
            bankName
            accountNumber
            accountType
            branchCode
            accountHolder
        }
    }
`;

